import React from 'react';

import { Filter } from '@gogame/filters';

import {
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_MONTH,
  FILTER_YEAR,
} from 'scenes/MarketingPlanning/components/SummaryByDirectorsDialog/constants';
import {
  loadAffiliates,
  loadApplications,
  loadNetworks,
} from 'scenes/MarketingPlanning/components/SummaryByDirectorsDialog/sources/summary';

//
const DEPENDENCIES = {
  [FILTER_AFFILIATES]: [FILTER_MONTH, FILTER_YEAR],
  [FILTER_APPLICATIONS]: [FILTER_MONTH, FILTER_YEAR],
  [FILTER_NETWORKS]: [FILTER_MONTH, FILTER_YEAR],
};

const AffiliatesFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Affiliates'}
      name={FILTER_AFFILIATES}
      source={loadAffiliates}
      withAll={false}
      placeholder={'All'}
      depends={DEPENDENCIES[FILTER_AFFILIATES]}
      {...props}
    />
  );
};

const ApplicationsFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={loadApplications}
      withAll={false}
      placeholder={'All'}
      depends={DEPENDENCIES[FILTER_APPLICATIONS]}
      {...props}
    />
  );
};

const NetworksFilter = (props) => {
  return (
    <Filter.MultiSelect
      title={'Networks'}
      name={FILTER_NETWORKS}
      source={loadNetworks}
      withAll={false}
      placeholder={'All'}
      depends={DEPENDENCIES[FILTER_NETWORKS]}
      {...props}
    />
  );
};

export default {
  Affiliates: AffiliatesFilter,
  Applications: ApplicationsFilter,
  Networks: NetworksFilter,
};
